<template>
    <glass-panel
        radius="lg"
        class="analytics-empty pa-8"
    >
        <div class="analytics-empty__icon">
            <v-icon
                size="40"
                color="primary"
            >
                {{ icon }}
            </v-icon>
        </div>

        <div class="analytics-empty__text">
            <eyebrow primary class="mb-2">
                Analytics em tempo real
            </eyebrow>
            <h2 class="analytics-empty__title">
                {{ title }}
            </h2>
            <p class="analytics-empty__desc">
                {{ description }}
            </p>
        </div>

        <div class="analytics-empty__visual" aria-hidden="true">
            <span class="orb orb--1" />
            <span class="orb orb--2" />
            <span class="orb orb--3" />
        </div>
    </glass-panel>
</template>

<script>
export default {
    name: 'AnalyticsEmptyState',
    props: {
        variant: {
            type: String,
            default: 'no-site',
            validator: v => ['no-site', 'error'].includes(v),
        },
    },
    computed: {
        icon() {
            return this.variant === 'error' ? 'mdi-cloud-off-outline' : 'mdi-chart-line-variant'
        },
        title() {
            return this.variant === 'error'
                ? 'Não conseguimos buscar seus analytics agora'
                : 'Conecte seu site para ver analytics em tempo real'
        },
        description() {
            return this.variant === 'error'
                ? 'Tivemos um problema ao consultar os dados do seu site. Tente recarregar a página em alguns instantes.'
                : 'Assim que seu site for ativado, esta área mostra visitantes, conversões, geografia e dispositivos atualizados diretamente do seu domínio.'
        },
    },
}
</script>

<style scoped>
.analytics-empty {
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 24px;
    align-items: center;
    min-height: 200px;
}

.analytics-empty__icon {
    width: 88px;
    height: 88px;
    border-radius: 9999px;
    background: rgba(112, 42, 225, 0.1);
    border: 1px solid rgba(112, 42, 225, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: var(--shadow-pulse);
    flex-shrink: 0;
}

.analytics-empty__text {
    min-width: 0;
}

.analytics-empty__title {
    font-family: var(--font-display);
    font-weight: 800;
    font-size: 1.5rem;
    line-height: 1.2;
    letter-spacing: -0.01em;
    color: var(--color-dark-violet);
    margin: 0 0 8px;
}

html.theme-dark .analytics-empty__title {
    color: var(--color-on-surface);
}

.analytics-empty__desc {
    font-family: var(--font-body);
    font-size: 0.9375rem;
    line-height: 1.55;
    color: var(--color-on-surface-variant);
    margin: 0;
    max-width: 560px;
}

.analytics-empty__visual {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
}

.orb {
    position: absolute;
    border-radius: 9999px;
    filter: blur(40px);
    opacity: 0.45;
}

.orb--1 {
    width: 220px;
    height: 220px;
    background: radial-gradient(circle, rgba(178, 140, 255, 0.55), transparent 70%);
    top: -60px;
    right: -40px;
}

.orb--2 {
    width: 180px;
    height: 180px;
    background: radial-gradient(circle, rgba(112, 42, 225, 0.35), transparent 70%);
    bottom: -40px;
    right: 120px;
}

.orb--3 {
    width: 140px;
    height: 140px;
    background: radial-gradient(circle, rgba(100, 72, 178, 0.3), transparent 70%);
    top: 40%;
    right: -20px;
}

@media (max-width: 640px) {
    .analytics-empty {
        grid-template-columns: 1fr;
        text-align: center;
    }
    .analytics-empty__icon {
        margin: 0 auto;
    }
}
</style>
